import React from 'react';
import { Dimmer, Loader } from 'semantic-ui-react';

const Loading = props => (
  <Dimmer active={ props.active } inverted>
    <Loader size="medium" />
  </Dimmer>
);

export default Loading;
